/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API22504Req {
  
  /** 英文名称 */
  resourceNameEn: string;
    
};



export interface API22504Res {
  /** 模块id  */
  moduleId?: string;
  /** 模块名称  */
  moduleName?: string;
  /** 模块标识  */
  moduleNameEn?: string;
  /** 模块描述  */
  moduleRemark?: string;
  /** 模块图标icon  */
  moduleIcon?: string;
  /** 云分类id  */
  cloudCategoryId?: string;
  /** 云分类名称  */
  cloudCategoryName?: string;
  /** 序号  */
  sort?: number;
  /** 菜单资源数量  */
  resourceNum?: number;
  /** 是否展示  */
  isShow?: boolean;
  /** 模块类型：DEFAULT ONLINE TRAILER  */
  moduleType?: string;
  /** 预告文案  */
  trailerText?: string;
  /** 产品负责人id  */
  productUserId?: string;
  /** 产品负责人名称  */
  productUserName?: string;
  /** 是否开放模块权限  */
  isPublish?: boolean;
  
};


// 22504 根据资源英文名称获取模块数据

export interface IUseGetAPI22504Return {
  /** 根据资源英文名称获取模块数据: 接口请求状态 */
  isAPI22504Loading: boolean;
  /** 根据资源英文名称获取模块数据: 接口请求返回数据 */
  dataAPI22504: API22504Res;
  /**  根据资源英文名称获取模块数据: 接口数据请求方法 */
  fetchAPI22504Data:  (inputs: API22504Req, config?: YWRequestConfig) => Promise<API22504Res>;
  /** 根据资源英文名称获取模块数据: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI22504 = ():IUseGetAPI22504Return => {
  let isMount = true;
  const [isAPI22504Loading, setIsAPI22504Loading] = useState(false);
  const [dataAPI22504, setDataAPI22504] = useState<API22504Res>({} as API22504Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/module/info/query`;

  const fetchAPI22504Data = async (inputs: API22504Req, config?: YWRequestConfig): Promise<API22504Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API22504Req>) || {}) as API22504Req;
    
  
    if ( isMount ) {
      setIsAPI22504Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API22504Res>(`${basePath}/ywwl-admin/desktop/module/info/query?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI22504(res || {} as API22504Res);
        setIsAPI22504Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI22504Loading(false);
      }
      return false as unknown as API22504Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI22504Loading,
    dataAPI22504,
    fetchAPI22504Data,
    requestUrl,
  }
}

